import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { EvaluationUseCases } from './evaluation.use-cases.contract';

import {
  EVALUATION_REPOSITORY,
  EvaluationRepository
} from '@/domain/repositories/evaluation/evaluation.repository.contract';
import { EvaluationFamilyType } from '@/enums/evaluation/evaluation.enum';
import { EvaluationDetail, EvaluationListItem } from '@/models/evaluation/evaluation.model';

@Injectable({
  providedIn: 'root'
})
export class EvaluationUseCasesImpl implements EvaluationUseCases {
  #evaluationRepository: EvaluationRepository = inject(EVALUATION_REPOSITORY);

  getEvaluations(evaluationFamilyType: EvaluationFamilyType): Observable<EvaluationListItem[]> {
    return this.#evaluationRepository.getEvaluations(evaluationFamilyType);
  }

  getEvaluationDetail(evaluationId: number): Observable<EvaluationDetail> {
    return this.#evaluationRepository.getEvaluationDetail(evaluationId);
  }
}
